<template>
  <div class="list list-index-entry">
  <h3>
    <router-link :to="{ name: 'ListView', params: { id: list.id }}">{{ list.title }}</router-link>
    <span v-if="!list.is_published" class="draft">📝</span>
    <span v-if="list.is_private" class="private">🔒</span>
  </h3>
  <p class="credit">
    <span v-if="user">
      by <router-link :to="{ name: 'UserView', params: { username: user.username }}">{{ user.username }}</router-link>,
    </span>
    {{ list.entries.length }} album<span v-if="list.entries.length !== 1">s</span>
  </p>

  <div class="placeholder" v-if="list.entries.length == 0"></div>
  <ul class="albums">
    <li v-for="entry in list.entries" v-bind:key="entry.id">
      <img width="100" height="100" :src="entry.album.thumbnail" />
    </li>
  </ul>
  </div>
</template>

<script>
export default {
  name: 'list-index-entry',
  props: {
    list: {
      type: Object,
      default () { return {entries: []} }
    },
    user: {
      default () { return false }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ListIndexEntry.vue